export const EVENT_TYPES = {
  'yu-gi-oh': 'Yu-Gi-Oh',
  'magic-the-gathering': 'Magic The Gathering',
  'one-piece': 'One Piece',
  'pokemon': 'Pokemon',
  'riftbound': 'Riftbound',
  'duel-masters': 'Duel Masters',
  'flesh-and-blood': 'Flesh and Blood',
  'lorcana': 'Lorcana',
  'warhammer': 'Warhammer',
  'boardgames': 'Boardgames'
};

export const EVENT_TYPE_OPTIONS = Object.entries(EVENT_TYPES).map(([value, label]) => ({
  value,
  label
}));
